/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue } from '../../../../Fct/generics/FctParams';
import { getSupportedTokens } from '../../../../Fct/plugins/allowanceRequiredProtocols';
export var Transfer = createPlugin({
    protocol: 'ERC20',
    type: 'ACTION',
    method: 'transfer',
    falseMeansFail: true,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({
                    destination: 'erc20',
                    options: getSupportedTokens({ chainId: chainId }),
                }),
                methodParams: {
                    recipient: new FctAddress({}),
                    amount: new FctValue({ destination: 'wei_amount' }),
                },
            },
            output: {},
        });
    },
});
